import { Close } from "@mui/icons-material";
import {
  Dialog,
  Fade,
  IconButton,
  Paper,
  Box,
  Stack,
  Grid,
  Typography,
} from "@mui/material";
import { theme } from "../../../utilities/themes";
import { useEffect, useState } from "react";
import MovieList from "./movieList";
import { filterMovies } from "./filterMovies";
import LocationChooser from "./locationChooser";

/**A card showing a cinema's movies on the home page
 * @param {Oject} props props
 * @param {Object} props.cinema the object containing the cinema's details
 * @param {number} props.index the index of the card in the list of cinema cards
 * @param {Function} props.handleExpand a function to expand and minimize cards based
 * on the one that is selected
 * @param {boolean} props.expanded whether the card is expanded or not
 * @param {Object[]} props.movies a list of movies
 */
const CinemaCard = ({
  cinema,
  index,
  handleExpand,
  expanded = false,
  movies,
}) => {
  /* #region  State, UI controllers and styling */
  const [_movieList, setMovies] = useState([]);
  const [filteredMovieList, setFilteredMovieList] = useState([]);
  const [hover, setHover] = useState(false);
  const [experience, setExperience] = useState("2D/3D");
  const [searchQuery, setSearchQuery] = useState("");
  const handleExperience = (event) => {
    setExperience(event.target.value);
    filterMovies(
      { experience: event.target.value, searchQuery },
      _movieList,
      setFilteredMovieList
    );
  };
  const handleSearchQuery = (event) => {
    setSearchQuery(event.target.value);
    filterMovies(
      { experience, searchQuery: event.target.value },
      _movieList,
      setFilteredMovieList
    );
  };
  const spanFontSizes1 = {
    fontSize: { lg: "1.125rem", md: "1rem", sm: "0.875rem", xs: "0.8rem" },
  };
  /* #endregion */

  /* #region  Initialization */
  const getMovies = () => {
    console.log(movies.map((movie) => movie.MovieID));
    let movieList = movies.filter((movie) => {
      if (movie.MovieID === "82483") {
        console.log("alhamdulilah", movie);
      }
      return movie.ShowTimes.some(
        (showTime) => showTime.MovieProviderID === cinema.MovieProviderID
      );
    });

    movieList && setMovies(movieList);
    filterMovies(
      { experience, searchQuery },
      movieList ? movieList : [],
      setFilteredMovieList
    );
  };
  useEffect(() => {
    getMovies();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* #endregion */

  const movieListProps = {
    experience,
    handleExperience,
    movies: filteredMovieList,
    moviesTab: false,
    cinema_Name: cinema.Name,
    cinema_id: cinema.MovieProviderID,
    searchQuery,
    handleSearchQuery,
  };
  return (
    <Paper
      sx={{
        p: 3,
        position: "relative",
        cursor: expanded ? "default" : "pointer",
        border: "1px solid rgb(200,200,200)",
        borderLeft: "5px solid #E4572E",
      }}
      elevation={hover ? 4 : 2}
      onClick={() => {
        if (!expanded) {
          handleExpand(index);
          setHover(false);
        }
      }}
      onMouseOver={() => !expanded && setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* <IconButton
        sx={{ position: "absolute", top: "1.75vh", right: "0.25vw" }}
        onClick={() => {
          handleExpand(index);
        }}
        size="large"
      >
        <ExpandMore
          color="primary"
          sx={{
            transform: expanded ? "rotate(180deg)" : "rotate(0)",
            fontSize: 24,
          }}
        />
      </IconButton> */}
      <Stack spacing={2} alignItems="center">
        <Box
          component="img"
          src={cinema.Logo}
          sx={{
            height: { xs: "15vh", sm: "20vh" },
            width: "auto",
            maxWidth: "90%",
            objectFit: "contain",
          }}
        />
        <Stack direction="row" alignItems={"center"}>
          {/* <Box component={"img"} src={cinema.Logo} height="auto" width="20%" /> */}
          <Typography
            component="span"
            sx={{
              ...spanFontSizes1,
              whiteSpace: "pre-wrap",
              textTransform: "uppercase",
              color: theme.palette.primary.main,
            }}
          >
            {cinema.Name}
          </Typography>
        </Stack>
        <Dialog
          open={expanded}
          onClose={() => handleExpand(index)}
          fullWidth={true}
          maxWidth="xl"
        >
          <Stack sx={{ p: 2 }}>
            <Stack direction={"row-reverse"}>
              <IconButton onClick={() => handleExpand(index)}>
                <Close color="primary" />
              </IconButton>
            </Stack>
            <MovieList {...movieListProps} />
          </Stack>
        </Dialog>
      </Stack>
    </Paper>
  );
};

/**Shows the list of cinema cards in the home page
 * @param {Object} props
 * @param {Object[]} props.cinemas a list of cinemas
 * @param {Object[]} props.movies a list of movies
 */
const CinemaList = ({ cinemas, movies, locations = [] }) => {
  /* #region  State and ui controllers */
  const [expandedCard, setExpanedCard] = useState(-1);
  const handleExpand = (index) => {
    expandedCard === index ? setExpanedCard(-1) : setExpanedCard(index);
  };
  /* #endregion */

  return (
    <Fade in>
      <Stack>
        {locations.length > 1 && (
          <Box sx={{ mb: 2 }}>
            <LocationChooser locations={locations} />
          </Box>
        )}
        <Grid container spacing={2}>
          {cinemas.map((cinema, index) => (
            <Grid item xs={12} sm={6} key={cinema.MovieProviderID}>
              <CinemaCard
                index={index}
                handleExpand={handleExpand}
                cinema={cinema}
                expanded={expandedCard === index}
                movies={movies}
              />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Fade>
  );
};
export default CinemaList;
